import { useEffect, useState } from 'react';
import { api, ApiRoutes } from '../../../../services/ApiService';
import { Category } from '../../../../types/Category';
import { branchCategoryIdsKey } from '../../../../helpers/branchCategoryHelper';

export function useOnboardingCategories(
    branchCategoryIds: number[],
    enabled: boolean
): { categories: Category[]; loading: boolean } {
    const branchCategoriesKey = branchCategoryIdsKey(branchCategoryIds);
    const [categories, setCategories] = useState<Category[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        let cancelled = false;

        const fetchCategories = async () => {
            try {
                setLoading(true);
                const queryParams: Record<string, string> = {};
                if (branchCategoryIds.length > 0) {
                    queryParams.branchCategoryIds = branchCategoriesKey;
                }

                const response = await api.get(ApiRoutes.CATEGORIES, undefined, queryParams);
                if (cancelled) {
                    return;
                }

                const loaded: Category[] = response.data?.data?.categories ?? [];
                setCategories(loaded);
            } catch (error) {
                if (!cancelled) {
                    console.error('Failed to fetch categories:', error);
                    setCategories([]);
                }
            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        };

        void fetchCategories();

        return () => {
            cancelled = true;
        };
    }, [branchCategoriesKey, branchCategoryIds.length, enabled]);

    return { categories, loading };
}
